import * as React from 'react'
import styled from 'styled-components'

interface Props {
  children?: React.ReactNode
  style?: React.CSSProperties
}

export default class Box extends React.Component<Props, any> {
  render() {
    const { children, style } = this.props
    return <Container style={style}>{children}</Container>
  }
}

const Container = styled.div`
  position: relative;
  grid-area: wizard;
  align-self: center;
  width: 100%;
  max-width: 550px;
  min-height: 310px;
  margin: auto;
  background: white;
  box-shadow: 10px 10px 20px #888;
`

export const FormContainer = styled.div`
  position: relative;
  grid-area: content;
  align-self: center;
  width: 100%;
  max-width: 550px;
  min-height: 310px;
  margin: auto;
  background: white;
  box-shadow: 10px 10px 20px #888;
`;



// WEBPACK FOOTER //
// ./src/components/containers/wizard/Box.tsx